// extracted by mini-css-extract-plugin
export var btn = "global-module--btn--kCldP";
export var btnWhite = "global-module--btnWhite--VPqpQ";
export var button = "global-module--button--NwNJA";
export var hasSquareMarker = "global-module--has-square-marker--19OzR";
export var headerSectionCommonGradientBackground = "global-module--header-section-common-gradient-background--FZXHm";
export var link = "global-module--link--oWxaF";